module.exports = __webpack_public_path__ + "static/wallet-7435120274e0f450462f24c74d14957f.png";